import { useState } from 'react';
import { ThemeProvider, createTheme, CssBaseline } from '@mui/material';
import LoginPage from './LoginPage';
import Dashboard from './Dashboard';
import AnalyticsPage from './AnalyticsPage';

const theme = createTheme({
  typography: {
    fontFamily: '"Inter", "Roboto", "Helvetica", "Arial", sans-serif',
  },
  palette: {
    primary: { main: '#0d3c61' },
  },
});

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(!!localStorage.getItem('stats_token'));
  const [page, setPage] = useState('dashboard');

  const handleLogin = () => setIsAuthenticated(true);
  const handleLogout = () => {
    localStorage.removeItem('stats_token');
    localStorage.removeItem('stats_user');
    setIsAuthenticated(false);
  };

  if (!isAuthenticated) {
    return (
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <LoginPage onLogin={handleLogin} />
      </ThemeProvider>
    );
  }

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      {page === 'dashboard' ? (
        <Dashboard onLogout={handleLogout} page={page} onPageChange={setPage} />
      ) : (
        <AnalyticsPage onLogout={handleLogout} page={page} onPageChange={setPage} />
      )}
    </ThemeProvider>
  );
}

export default App;
